import { useStaticQuery, graphql } from "gatsby";

export const useSearch = (keyword, dataType, isSearch) => {
  const checkWithKeyword = (type, data, search) => {
    if (type === "products") {
      if (data.title.toLowerCase().includes(search.toLowerCase())) return true;
      
      const sku = data.skuNumber.split("#")[1];
      if (data.skuNumber.toLowerCase() === search.toLowerCase() || sku === search)
        return true;
    } else if (type === "tag") {
      if (data.toLowerCase().includes(search.toLowerCase())) return true;
    }

    return false;
  };

  const data = useStaticQuery(graphql`
    query {
      allContentfulProduct {
        edges {
          node {
            id
            url
            rto
            financingAvailable
            skuNumber
            title
            image {
              gatsbyImageData(quality: 50, placeholder: BLURRED)
              fluid {
                srcWebp
              }
            }
            price
            width
            length
            height
            city
            state
            zipcode
            location {
              lat
              lon
            }
            buildingCondition
            description {
              childMarkdownRemark {
                html
              }
            }
            specifications {
              childMarkdownRemark {
                html
              }
            }
            productCategories {
              title
            }
            buildingTags
            roofStyleType
            manufacturer
            gaugeTubing
            gaugePanels
          }
        }
      }
    }
  `);

  if (!isSearch && !keyword)
    return {
      results: [],
    };

  const products = data.allContentfulProduct.edges;
  let tTags = [];
  products.forEach((p) => {
    if (p.node.buildingTags) {
      tTags = [...tTags, ...p.node.buildingTags];
    }
  });
  const tags = [...new Set(tTags.map((tag) => tag.trim()))];

  const rProducts = (products || [])
    .map((p) => p.node)
    .filter((p) => checkWithKeyword("products", p, keyword));

  if (dataType === "products") {
    return {
      results: [...rProducts],
    };
  }

  const rTags = (tags || [])
    .filter((tag) => checkWithKeyword("tag", tag, keyword))
    .map((t) => ({ title: t, type: "tag" }));

  return {
    results: [...rProducts, ...rTags],
  };
};
